import { render } from "./HeaderSimple.vue?vue&type=template&id=1e301b2a"
import script from "./HeaderSimple.vue?vue&type=script&lang=js"
export * from "./HeaderSimple.vue?vue&type=script&lang=js"

import "./HeaderSimple.vue?vue&type=style&index=0&id=1e301b2a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__